import { inject } from "@angular/core";
import { type CanActivateFn, type UrlTree } from "@angular/router";
import { WEB3_MERGE_PHASE, Web3Facade } from "@modules/web3/+state/web3.facade";
import { Observable, combineLatest, of, switchMap } from "rxjs";
import { Web3NavigationService } from "../services/web3.navigation";
import { extractBasePath } from "@modules/trade/helpers/helper";

export const web3VisionGuardFn: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
	const facade = inject(Web3Facade);
	const basePath = extractBasePath(state.url);
	const navigation = inject(Web3NavigationService);

	return combineLatest({
		mergePhase: facade.getMergePhase(),
		hasVision: facade.userHoldsVision(),
		hasBestPan: facade.userHoldsBestOrPan()
	}).pipe(
		switchMap(({ mergePhase, hasVision, hasBestPan }) => {
			if (mergePhase.phase === WEB3_MERGE_PHASE.PostMerge && !hasVision && !hasBestPan) {
				return of(navigation.createUrlTree(basePath));
			}
			return of(true);
		})
	);
};
